export enum PersonSource {
    Manual = 0,
    WhatsApp = 1,
    AdClick = 2,
    Website = 3,
    Instagram = 4,
    Email = 5,
    TikTok = 6,
    Telegram = 7,
    Sms = 8,
    Import = 9,
    RdStation = 10,
}

export enum PersonSourceDetail {
    MetaLeadForm = 1,
    FacebookLeadForm = 2,
    InstagramLeadForm = 3,
    InstagramAdMessage = 4,
    WhatsAppAdMessage = 5,
    MessengerAdMessage = 6,
}

export interface PersonResponse {
    id: string;
    name: string;
    phone: string;
    email?: string | null;
    notes?: string | null;
    source: PersonSource;
    sourceDetail?: PersonSourceDetail | null;
    createdAt: string;
    companyId?: string | null;
    /// O nome da empresa ligada, para a lista mostrar.
    companyName?: string | null;
    address?: PersonAddress | null;
    profile: PersonProfile;
}

export enum EPersonSex {
    Male = 1,
    Female = 2,
}

export enum EMaritalStatus {
    Single = 1,
    Married = 2,
    StableUnion = 3,
    Divorced = 4,
    Widowed = 5,
}

/// Dados pessoais, todos opcionais; birthDate em yyyy-MM-dd, CPF e telefones só com dígitos.
export interface PersonProfile {
    birthDate?: string | null;
    sex?: EPersonSex | null;
    cpf?: string | null;
    maritalStatus?: EMaritalStatus | null;
    secondContactName?: string | null;
    secondContactPhone?: string | null;
}

/// UF é o número do EBrazilianUf.
export interface PersonAddress {
    postalCode: string;
    streetName: string;
    number?: string | null;
    complement?: string | null;
    district?: string | null;
    city: string;
    state: number;
}

/// O mínimo para escolher uma pessoa num seletor.
export interface PersonOptionResponse {
    id: string;
    name: string;
    phone: string;
    email?: string | null;
}

/// SamePerson: telefone e dados batem com alguém cadastrado, e a importação só completa o vazio.
/// PhoneConflict: o telefone é de alguém cadastrado, mas os dados divergem; nada grava.
export enum EImportRowStatus {
    New = 0,
    SamePerson = 1,
    RepeatedInFile = 2,
    Invalid = 3,
    PhoneConflict = 4,
    /// O e-mail é de uma linha anterior ou de alguém cadastrado: fica de fora.
    EmailInUse = 5,
}

export type ImportConflictField = 'name' | 'email';

/// Coluna do lead aberto do telefone num quadro: lá a importação não cria outro.
export interface OpenLeadInBoard {
    boardId: string;
    columnName: string;
}

/// openLeads traz um item por quadro em que o telefone já tem lead aberto.
export interface PeopleImportPreviewRow {
    line: number;
    status: EImportRowStatus;
    problems: string[];
    matchId: string | null;
    matchName: string | null;
    matchPhone: string | null;
    matchEmail: string | null;
    repeatsLine: number | null;
    conflicts: ImportConflictField[];
    openLeads: OpenLeadInBoard[];
}

export interface PeopleImportResult {
    created: number;
    updated: number;
    repeated: number;
    conflicts: number;
    invalid: number;
    leadsCreated: number;
    leadsReopened: number;
    leadsSkipped: number;
    createdWithoutPhone: number;
    leadsWithoutPhone: number;
}
